/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';

import close from '../assets/images/close.svg'
import fileImageIcon from "../assets/images/upload.svg"
import UploadedPopupMedia from './UploadedPopupMedia';
import '../assets/css/mediapopup.css'
import useMediaUpload from '../hooks/useMediaUpload';
import { getAllMedia } from '../api/mediaApi';

function UploadMediaPopup(props) {
    const { setShowUploadMediaPopup, setSelectedProfileImage, uploadMediaPopupFor, uploadMediaPopupTab, selectedMedia, setPreviousImages } = props;

    const INITIAL_LOAD = 36;
    const LOAD_MORE_COUNT = 9;

    const fileInputRef = useRef(null);
    const popupRef = useRef();

    const [currentTab, setCurrentTab] = useState(uploadMediaPopupTab);
    const [isImageDragging, setIsImageDragging] = useState(false);
    const [allMedia, setAllMedia] = useState([]); // Store all media fetched from API
    const [displayMedia, setDisplayMedia] = useState([]); // Media currently displayed
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const [hasUserScrolled, setHasUserScrolled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedItems, setSelectedItems] = useState(selectedMedia || [])
    const [errorMessages, setErrorMessages] = useState([])
    const [searchInput, setSearchInput] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState(searchInput);
    const [fileList, setFileList] = useState({
        '^image/': 'Images',
        '^video/': 'Videos',
        'application/pdf': 'PDF',
        'application/doc': 'DOC',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
        'application/vnd.ms-powerpoint': 'PPT',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12': 'PPTM',
        'application/vnd.ms-excel': 'XLS',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
        'application/vnd.ms-excel.sheet.macroenabled.12': 'XLSM'
    });

    const { handleMeidaUpload } = useMediaUpload(setDisplayMedia, setErrorMessages, fileList);

    const popupTitles = {
        'cover-picture': 'Cover Picture',
        'profile-picture': 'Profile Picture',
        'feature-image': 'Featured Image',
        'docfiles-selection': 'File Library',
        'video-file': 'Video Library',
        'images-file': 'Image Library',
        'editor-image': 'Select Image',
        'editor-video': 'Video Library'
    }

    const allowFileType = {
        'cover-picture': 'image/*',
        'profile-picture': 'image/*',
        'editor-image': 'image/*',
        'feature-image': 'image/*',
        'images-file': 'image/*',
        'video-file': 'video/*',
        'editor-video': 'video/*',
        'docfiles-selection': '.pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx'
    }

    const popupTitle = popupTitles[uploadMediaPopupFor];

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchInput);
        }, 400); // debounce delay (ms)

        return () => {
            clearTimeout(handler); // cancel previous timer
        };
    }, [searchInput]);

    const fetchData = async () => {
        setIsLoading(true)
        try {
            const response = await getAllMedia({ search: debouncedSearch })
            if (response?.data?.length <= 0) {
                setIsLoading(false)
            }
            if (response?.success) {
                const allData = response?.data || [];
                setAllMedia(allData);
                setDisplayMedia(allData.slice(0, INITIAL_LOAD));
                setPage(1); // important
                setHasMore(allData.length > INITIAL_LOAD);
                setIsLoading(false)
            }
        } catch (error) {
            setIsLoading(false)
            console.log(error, "error");
        }
    }

    useEffect(() => {
        fetchData()
    }, [debouncedSearch]);

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            if (popupRef.current && !popupRef.current.contains(e.target)) {
                setShowUploadMediaPopup(false)
                if (typeof setPreviousImages === 'function') {
                    setPreviousImages(false)
                }
            }
        };

        document.addEventListener("mousedown", checkIfClickedOutside);

        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, []);

    useEffect(() => {
        if (uploadMediaPopupFor === 'video-file') {
            setFileList({
                '^video/': 'Videos',
            });
        } else if (uploadMediaPopupFor === 'docfiles-selection') {
            setFileList({
                'application/pdf': 'PDF',
                'application/doc': 'DOC',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
                'application/vnd.ms-powerpoint': 'PPT',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
                'application/vnd.ms-powerpoint.presentation.macroenabled.12': 'PPTM',
                'application/vnd.ms-excel': 'XLS',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
                'application/vnd.ms-excel.sheet.macroenabled.12': 'XLSM'
            });
        } else {
            setFileList({
                '^image/': 'Images',
            });
        }
    }, [uploadMediaPopupFor]);

    useEffect(() => {
        if (currentTab) {
            const handleKeyDown = (e) => {
                const deleteMediaElement = document.getElementById('deleteMedia');
                if (e?.key === 'Enter' && currentTab === "media" && deleteMediaElement?.children?.length > 0) {
                    // handleDeleteButton()
                } else if (e?.key === "Escape") {
                    setShowUploadMediaPopup(false)

                }
            };
            document.addEventListener("keydown", handleKeyDown);
            return () => {
                document.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [currentTab]);

    const handleFileDragOver = (e) => {
        e.preventDefault();
        if (!isImageDragging) {
            setIsImageDragging(true);
        }
    }

    const handleFileDragLeave = (e) => {
        e.preventDefault();
        setIsImageDragging(false);
    };

    const handleGalleryImageDrop = async (e) => {
        e.preventDefault();

        const files = e.dataTransfer.files;
        await handleMeidaUpload(files);
        setCurrentTab('media');

        setIsImageDragging(false);
    };


    const handleImageGalleryUpload = async (e) => {
        const files = e.target.files;
        await handleMeidaUpload(files);
        setCurrentTab('media');
    }

    const fetchMoreData = () => {
        if (isFetchingMore) return;

        setHasUserScrolled(true); // 👈 key line
        setIsFetchingMore(true);

        requestAnimationFrame(() => {
            setTimeout(() => {
                const startIndex = INITIAL_LOAD + (page - 1) * LOAD_MORE_COUNT;
                const endIndex = startIndex + LOAD_MORE_COUNT;

                const nextItems = allMedia.slice(startIndex, endIndex);

                if (nextItems.length === 0) {
                    setHasMore(false);
                    setIsFetchingMore(false);
                    return;
                }

                setDisplayMedia(prev => [...prev, ...nextItems]);
                setPage(prev => prev + 1);
                setHasMore(endIndex < allMedia.length);
                setIsFetchingMore(false);
            }, 400);
        });
    };

    const InfiniteLoader = () => (
        <div className='infinateLoader'>
            <div className="infinatescroll ringLoader">
            </div>
        </div>
    );

    return (
        <div className="mediaPopupContainer uploadMediaPopup ">
            <div className='popup-overlay'></div>
            <div className='popupBlock popupBlockPlan mediapopupBlock' ref={popupRef}>
                <div className='popupBlock-wrapper uploadMediaPopupOverflow' id="uploadMediaPopupScrollable">
                    <div className="popupBlock-inner">
                        <div className="popupTop popupTopClose closePlan uploadMediaPopupCloseIcon">
                            <img src={close} onClick={e => {
                                setShowUploadMediaPopup(false); if (typeof setPreviousImages === 'function') {
                                    setPreviousImages(false)
                                }
                            }} alt="Icon" />
                        </div>

                        <div className="popupContent">
                            <p className="popupTitle">{popupTitle}</p>
                            <ul className="tabTitle">
                                <li className={`${currentTab === 'upload' ? 'active' : ''}`} onClick={() => setCurrentTab('upload')}>Upload</li>
                                <li className={`${currentTab === 'media' ? 'active' : ''}`} onClick={() => setCurrentTab('media')}>Media Library</li>
                            </ul>
                        </div>
                        {currentTab === 'upload' ? (
                            <div className={`newpageLeftRow textBlock ulpoadImageBlock`} id="deleteMedia">
                                <div className={isImageDragging ? `draging fileUploadBox` : `fileUploadBox`} onDragOver={handleFileDragOver} onDragLeave={handleFileDragLeave} onDrop={handleGalleryImageDrop} >
                                    <input type="file" ref={fileInputRef} id="pulication-file" multiple hidden accept={allowFileType[uploadMediaPopupFor]} onChange={handleImageGalleryUpload} />
                                    <div className="uploadFileBlock" onClick={() => document.getElementById("pulication-file").click()} >
                                        <div className="featureImgMiddleContent">
                                            <img className="fileUploadCover_Img" src={fileImageIcon} alt="FeaturedImage" />
                                            <p className="newPageImageUploadText">
                                                <span>Click to upload</span> or drag and drop{" "}
                                                {(uploadMediaPopupFor === 'cover-picture' || uploadMediaPopupFor === 'profile-picture' || uploadMediaPopupFor === 'feature-image' || uploadMediaPopupFor === 'images-file' || uploadMediaPopupFor === 'editor-image') &&
                                                    <>
                                                        <br />
                                                        <b>Images: </b> JPG, PNG
                                                    </>
                                                }
                                                {(uploadMediaPopupFor === 'video-file' || uploadMediaPopupFor === "editor-video") &&
                                                    <>
                                                        <br />
                                                        <b>Videos: </b> MP4, MOV, AVI, WMV, AVCHD, WebM, FLV
                                                    </>
                                                }
                                                <br />
                                                {/* (max. 128MB) */}
                                            </p>
                                            {errorMessages && errorMessages.length > 0 && (
                                                <div className="errorMessages">
                                                    {errorMessages.map((errorMessage, index) => (
                                                        <p key={index} className="error-message">{errorMessage}</p>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <UploadedPopupMedia setUserMedia={setDisplayMedia} userMedia={displayMedia} selectedItems={selectedItems} setSelectedItems={setSelectedItems} isLoading={isLoading} setShowUploadMediaPopup={setShowUploadMediaPopup} setSelectedProfileImage={setSelectedProfileImage} uploadMediaPopupFor={uploadMediaPopupFor} fetchMoreData={fetchMoreData} hasUserScrolled={hasUserScrolled} isFetchingMore={isFetchingMore} hasMore={hasMore} InfiniteLoader={InfiniteLoader} searchInput={searchInput} setSearchInput={setSearchInput} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadMediaPopup;